
function GetSuggestedProducts() {

    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
            cache: false,
            success: function (dt) {

                dt = dt.replace("_buyuk", "_kucuk");

                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {

                    //$(".AutoGetSuggested").html(dt);

                    //$(".AutoGetSuggested .ProductList .Prd").addClass("col-sm-6");
                    //$(".AutoGetSuggested .ProductList .Prd").addClass("col-xs-12");
                    //$(".AutoGetSuggested .ProductList .Prd:gt(3)").addClass("hidden-xs");

                    $(".AutoGetSuggested").append(dt);

                    //$(".AutoGetSuggested .ProductList").removeClass("grid-wrapper").addClass("grid-wrapper-product-details");
                    //$(".AutoGetSuggested .ProductList .Prd").removeClass("grid").addClass("grid-product-details");
                    //$(".AutoGetSuggested .ProductList .Prd a .img2").remove();
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");
                }

                //if ($(window).width() < 767) {

                SuggestPrdSlider();
                //}


            }
        });
    }
}

function addQuantity() {
    $(".AmountOptions a").live("click", function () {
        var InputItem = $(this).closest(".AmountOptions").find("#Amount");
        if ($(this).hasClass("BasketPlus")) {
            InputItem.attr('value', parseInt(InputItem.val()) + 1);
        }
        if ($(this).hasClass("BasketMinus") && InputItem.val() > 0) {
            InputItem.attr('value', parseInt(InputItem.val()) - 1);
        }

    });
}

function GetHashImage() {

    //var CurHash = window.location.hash;

    //if (CurHash != undefined && CurHash.length > 0 && CurHash.indexOf("#C=") > 0) {
    //    CurHash = CurHash.replace("#", "");
    //    var newHash = CurHash.replace("#", "").split("=")[1];
    //    $colorID = $(".ProductDetail .Colors a[data-id=" + newHash + "]");

    //    if ($colorID.length > 0) {
    //        $colorID.trigger("click");
    //    }

    //}

    if (window.location.hash != undefined && window.location.hash != "") {

        var colorHash = window.location.hash.split("=");
        var ColorID = colorHash[1];

        currentColorID = $(".Colors a.active:first").attr("data-id");

        if (currentColorID == ColorID) {

            //RunSlickSlider();
        }

        if (currentColorID != ColorID) {

            if ($(".ProductDetail .Colors a[data-id='" + ColorID + "']").length > 0) {

                $(".ProductDetailImages img").remove();
                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");

            }

        }
        else if ($("#CurCatalogID").length > 0) {

            GetSuggestedProducts();
        }
    }
    else {
        //RunSlickSlider();
    }

}

var LastVisitedPrds = [];

function GetLastVisitedPrdView(productData) {

    if ($(".AutoGetLastVisited").length > 0) {

        //var prdDataList = "";
        //for (var i = 0; i < productData.length; i++) {

        //    prdDataList += "lastviewedPrds.[" + i + "].Amount=" + productData[i].Amount;
        //    LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, ProductName: _prdname });

        //}
        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProductsView",
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {


                $(".LastViewedProducts.AutoSetted").remove();

                if (dt != "") {

                    //$(".AutoGetLastVisited .container").append(dt);

                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
                    $(".LastViewedProducts .ProductList .Prd a .img2").remove();

                }

            }
        });
    }
}

$("#SingOut").live("click", function (e) {
    if (!isAppleMobile()) {
        localStorage.removeItem("LastVisitedPrds");
    }
});

$("body").on("submit", ".AskQuestionForm", function (e) {
    $.ajax({
        type: 'post',
        url: $(".AskQuestionForm").attr("action"),
        data: $(".AskQuestionForm").serialize(),
        async: true,
        success: function (dt) {

            if (dt.Sonuc == true) {

                $("#Infos").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                $(".AskQuestionForm").hide();

            }
            else {

                $("#AlertResult").addClass("alert-danger");
                $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
            }

        },
        error: function () {

            alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
        }
    });

    e.preventDefault();
    return false;
});

$('#StoreStocksbtn').live("click", function (e) {
    var ProductID = $("#ProductID").val();
    var ColorID = $("#ColorID").val();
    var SizeID = $("#StoreStockOptionsDetail select[name='BedenMagazaAra']").val();

    if ((SizeID != null && SizeID != undefined && SizeID != "") && (ColorID != null && ColorID != undefined && ColorID != "") && (ProductID != null && ProductID != undefined && ProductID != "")) {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetStoreStocks?ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID,
            success: function (data) {

                $(".StoreStockBody").html(data);

            }
        });
    }
    else {

        if (SizeID == null || SizeID == undefined || SizeID == "") {
            alert("Lütfen Beden Seçiniz..");
        }
        else if (ColorID == null || ColorID == undefined || ColorID == "") {
            alert("Lütfen Renk Seçiniz..");
        }
        else if (ProductID == null || ProductID == undefined || ProductID == "") {

            alert("Bir hata oluştu lütfen sayfayı yenileyerek tekrar deneyiniz.");

        }

    }
});

function SetLastVisitedProductsStorage() {
    if (typeof (Storage) !== "undefined") {

        if ($(".ProductHeader:first").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now)
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem("LastVisitedPrds");
                    //localStorage.clear();
                    localStorage.setItem('prdLastSetupTime', now);
                    console.log('Local Storage silindi! ProductDetails.js');
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = localStorage.LastVisitedPrds;

            if (LastVisitedPrds == undefined) {
                LastVisitedPrds = [];
            } else {
                LastVisitedPrds = JSON.parse(LastVisitedPrds);
            }

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {

                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg.replace("_1_", "_2_"), ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }
                localStorage.LastVisitedPrds = JSON.stringify(LastVisitedPrds);
            }

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {

                GetLastVisitedPrdView(LastVisitedPrds);
            }
        }
        else {
            // 'fastLocalStorageUpdate' değeri ile versiyon geçişinden(JimmyKey V2 geçişi) sonra kullanıcı tarafında yaşanan siteye giriş hatalarının düzeltilmesi amaçlandı.
            var fastUpdate = localStorage.getItem('fastLocalStorageUpdate');

            if (fastUpdate === null || fastUpdate === true) {
                localStorage.clear();
                localStorage.setItem('fastLocalStorageUpdate', false);

                console.log('"fastLocalStorageUpdate" localStorage üzerinde işlem yapıldı!');
            }
        }

    } else {
        console.warn("Tarayıcının localstorage desteği bulunmuyor.");
    }

}

function Get5thAngleCombine() {

    if ($(".CombineProductsOnPd .Prd").length > 0) {

        var imagePath1thAngle = $(".CombineProductsOnPd .Prd:first .img1").attr("src");

        var ImgExist = false;
        var BeginAngle = 5;
        var NewImagePathAngle = "";
        $curImg = $(".CombineProductsOnPd .ProductList .Prd:first .img1");

        if (!ImgExist && $curImg.attr("src") != undefined && $curImg.attr("src").indexOf("5_buyuk") <= 0) {

            NewImagePathAngle = imagePath1thAngle.replace("1_buyuk", "1_buyuk");

            ImgExist = true;

            $curImg.attr("src", NewImagePathAngle);

            $curImg.error(function () {
                $curImg.attr("src", imagePath1thAngle);
            });
        }
    }
}

function ReplaceCombineProducts() {

    if ($(".CombineProductsOnPd .Prd").length > 0) {

        //$(".CombineProductsOnPd .Prd:first").append('<div class="equals">=</div>');

        // Kombindeki ilk ürünün fiyat bilgilerini sildiği için kapatılan satırlar
        //$(".CombineProductsOnPd .Prd:first > a").attr("href", $(".CombineButton").attr("href"));
        //$(".CombineProductsOnPd .Prd:first .PName").html($(".CombineButton").attr("data-title"));

        //$priceSpan = $(".CombineProductsOnPd .Prd:first .PPrice span").clone();
        //$combineButton = $(".CombineInfoPd .CombineButton").clone();

        //$(".CombineProductsOnPd .Prd:first .PPrice").remove();
        //$(".CombineProductsOnPd .Prd:first").append($combineButton);

        //$(".CombineProductsOnPd .Prd:gt(0)").addClass("SmallPrd");

        Get5thAngleCombine();
    }
}

function DetailResizing() {

    $(".CombineProductsOnPd .Productsuggest .ProductList").addClass("col-xs-24");


    if ($(window).width() <= 991) {

        $(".ProductDetailsMainImage ul li img").each(function () {
            $(this).attr("src", $(this).attr("src").replace("_buyuk", "_614x805"))
        });
    }


    $(window).resize(function () {


        if ($(window).width() <= 991) {

            $(".ProductDetailsMainImage ul li.ImgArea img").each(function () {
                $(this).attr("src", $(this).attr("src").replace("_buyuk", "_614x805"))
            });
        }
    });
}

function AskQuestions() {

    $("body").on("click", ".AskQuestion", function () {
        $("#AskQuestion").modal();
    });

    $('#AskQuestion').on('shown.bs.modal', function () {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/AskQuestions",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                $("#AskQuestion  .formArea").html("");

                $("#AskQuestion  .formArea").html(dt);
                $("#AskQuestion  .formArea .HiddenItems").find("#ColorID").val($(".Colors div a.active").data("id"));
                $("#AskQuestion  .formArea .HiddenItems").find("#ProductID").val($(".Prices #ProductID").val());
            }
        });
    });
}

function SizeTable() {
    $(".SizeTable").live("click", function () {
        $("#SizeTable").modal();
    });
}

function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }
    });
}

function CombinePrdSlider() {
    var slidesToShowNumber = 2;

    //if ($(window).width() < 767) {
    //    slidesToShowNumber = 1;
    //}

    $(".CombineProductsOnPd img.img2").remove();

    $(".CombineProductsOnPd .ProductList .ProductList").slick({
        nextArrow: '<div class="PrdDetayImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdDetayImgLeft left-arrow"></div>',
        slidesToShow: slidesToShowNumber,
        slidesToScroll: 1,
        arrows: true,
        useTransform: false,
    });
}

function SuggestPrdSlider() {
    //$(".AutoGetSuggested img.img2").remove();

    //$(".AutoGetSuggested .ProductList .ProductList").slick({
    //    nextArrow: '<div class="PrdDetayImgRight right-arrow"></div>',
    //    prevArrow: '<div class="PrdDetayImgLeft left-arrow"></div>',
    //    slidesToShow: 2,
    //    slidesToScroll: 1,
    //    arrows: true,
    //    useTransform: false,
    //});
}

function Slider() {
    $().fancybox({
        selector: '.js-fancy-image-item:not(.slick-cloned)',
        slideShow: {
            autoStart: false,
            speed: 2000
        },
        buttons: [
            "zoom",
            "slideShow",
            "close"
        ],
        loop: false,
        thumbs: {
            autoStart: false
        },
        backFocus: false,
        afterClose: function (instance, current) {
            var videoItem = $('.js-fancy-image-item.video-item');

            var video = videoItem.find('video');
            if (video.length) {
                video[0].play();
            }

            videoItem.css('display', '');
        }
    });

    if ($(window).width() < 992) {
        $('.ProductDetailsMainImage ul').slick({
            nextArrow: '<div class="PrdImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdImgLeft left-arrow"></div>',
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });
    }

    //$('.SmallProductImages ul').slick({
    //    slidesToShow: 4,
    //    slidesToScroll: 1,
    //    //asNavFor: '.ProductDetailsMainImage ul',
    //    prevArrow: '<div class="PrdImgLeft left-arrow slick-arrow"><span class="glyphicon glyphicon-menu-up"></span></div>',
    //    nextArrow: '<div class="PrdImgRight right-arrow slick-arrow"><span class="glyphicon glyphicon-menu-down"></span></div>',
    //    focusOnSelect: true,
    //    vertical: true,
    //    lazyLoad: 'ondemand'
    //});

    $(document).on("click", ".ProductDetailsMainImage  .js-fancy-image-item:not(.slick-cloned)", function () {
        $(".ProductDetailsMainImage  .js-fancy-image-item").each(function () {
            var thisImage = $(this).find(".main-image");
            var thisAttr = thisImage.attr("data-lazy");

            if (thisAttr != "" && thisAttr != undefined) {
                thisImage.attr("src", thisImage.attr("data-lazy"));
                thisImage.removeAttr("data-lazy");
            }
        });
    });

}

function AddToFavoriteNewPd() {
    var ColorID = $("#ColorID").val();
    var ProductID = $("#ProductID").val();

    $("#ProductDetailDivi").find(".passiveFavorite").live("click", function () {
        $That = $(this);
        var ProductCode = $(this).attr("data-productcode");
        var ProductName = $(this).attr("data-productname");
        var ColorName = $(this).attr("data-colorname");
        //var quantity = $(this).attr("data-quantity");
        var price = parseFloat($(this).attr("data-amount"));
        var priceOld = parseFloat($(this).attr("data-amountPsf"));
        var discount = $(this).attr("data-discount");

        var category1 = $(this).attr('data-category1');
        var category2 = $(this).attr('data-category2');
        var category3 = $(this).attr('data-category3');
        var catID = $(this).attr('data-catID');
        var itemListName = $(this).attr('data-itemListName');

        discount = priceOld - price;
        if (price == priceOld) {
            discount = 0;
        }

        var amount = price;
        if (amount == 0) {
            amount = priceOld;
        }

        var value = parseFloat(amount);

        var storedCatalog = localStorage.getItem('selectedCatalog');
        var storedCatalogID = localStorage.getItem('selectedCatalogID')

        window.dataLayer = window.dataLayer || [];
        try {
            window.dataLayer.push({
                event: "add_to_wishlist",
                ecommerce: {
                    currency: 'TRY',
                    value: value,
                    items: [
                        {
                            item_id: ProductCode,
                            item_name: ProductName,
                            affiliation: category1,
                            coupon: "",
                            currency: 'TRY',
                            discount: discount,
                            index: 0,
                            item_brand: 'JMK',
                            item_category: category1,
                            item_category2: category2,
                            item_category3: category3,
                            item_list_id: parseInt(storedCatalogID),
                            item_list_name: storedCatalog,
                            item_variant: ColorName,
                            location_id: 'İZ',
                            price: parseFloat(priceOld),
                            quantity: 1
                        }
                    ]
                }
            });
        } catch (e) {

        }

        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $(".AddToBasketFixed .AddToFavorite").addClass("activeFavorite");

                        $That.removeClass("passiveFavorite");
                        $(".AddToBasketFixed .AddToFavorite").removeClass("passiveFavorite");

                        $That.children("img").attr("src", "/Images/JMK/Icons/dolukalp.png");
                        $(".AddToBasketFixed .AddToFavorite > img").attr("src", "/Images/JMK/Icons/dolukalp.png");

                        //#region Related Datalayer Add To Favorite Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion

                    }
                    else if (dt.Sonuc == false) {
                        //alert('Favorilere eklemek için giriş yapınız!');
                        $("#LoginRegisterModal").modal("show");

                        var modalBody = document.querySelector("#LoginRegisterModal .modal-body");

                        // Eğer script daha önce eklenmediyse, modal içine ekle
                        if (modalBody && $("#LoginRegisterModal .cf-turnstile-script").length === 0) {
                            var turnstileScript = document.createElement("script");
                            turnstileScript.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
                            turnstileScript.async = true;
                            turnstileScript.defer = true;
                            turnstileScript.className = "cf-turnstile-script";

                            // Turnstile scriptini modal-body içine ekle
                            document.querySelector("#LoginRegisterModal .modal-body").appendChild(turnstileScript);
                        }

                        var memberlessBtn = document.querySelector(".ContinueWithoutMember");
                        if (memberlessBtn) {
                            memberlessBtn.remove();
                        }
                    }
                },
                error: function (httpObj, textStatus) {

                    //if (httpObj.status == 401) {
                    //    alert('Favorilere Eklemek için giriş yapınız.');
                    //}
                    //else {
                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    //}
                }
            });
        }
    });
}

function removeFavoriteNewPd() {
    var ColorID = $("#ColorID").val();
    var ProductID = $("#ProductID").val();

    $("#ProductDetailDivi").find(".activeFavorite").live("click", function () {
        $That = $(this);

        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'productID=' + ProductID + '&colorID=' + ColorID + '&isDetail=true',
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $(".AddToBasketFixed .AddToFavorite").addClass("passiveFavorite");

                        $That.removeClass("activeFavorite");
                        $(".AddToBasketFixed .AddToFavorite").removeClass("activeFavorite");

                        $That.children("img").attr("src", "/Images/JMK/Icons/kalp.png");
                        $(".AddToBasketFixed .AddToFavorite > img").attr("src", "/Images/JMK/Icons/kalp.png");

                        //#region Related Datalayer Remove From Favorite Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion
                    }
                },
                error: function (httpObj, textStatus) {
                    if (httpObj.status == 401) {
                        alert('Favorilerden çıkartmak için giriş yapınız.');
                    }
                    else {
                        alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }
                }
            });
        }
    });
}

function RemoveBasketCount() {
    $(".ProductDetailsMainImage .BasketCountPopup").fadeOut("slow", function () {
        $(this).remove();
    });
}

function AddBasketCount() {
    var basketCount = $("#BasketCount").val();
    if (basketCount != '' && basketCount >= 2 && $(window).width() > 767) {

        var popup = $("<div class=\"BasketCountPopup\">" +
            "<div class=\"trinagleOuther\">" +
            "<span class=\"glyphicon glyphicon-triangle-top\"></span>" +
            "</div>" +
            "<img src=\"/Images/JMK/Icons/sepet_mobile_yeni.png\"/>"
            + $("#BasketCountMessage").val()
            + "</div>").hide();
        popup.appendTo($(".ProductDetailsMainImage")).fadeIn(1500);
        window.setTimeout(RemoveBasketCount, 9000)
    }
}

function StoreStockInfo() {
    $(".store-stock-info").live("click", function () {
        var _productcode = $('.store-stock-info').data('productcode');
        var _colorCode = $('.store-stock-info').data('colorcode');
        var _productSizeString = $('.store-stock-info').data('sizes');
        var _productSizes = _productSizeString.split(',');
        var _jsonProductSizesString = JSON.stringify(_productSizes);

        $.ajax({
            url: '/ProductDetails/WhichStoreIsTherePage',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                productCode: _productcode,
                colorCode: _colorCode,
                productSizes: _productSizes
            }),
            success: function (data) {
                // Populate the modal content with the returned data
                $("#store-stock-info-modal .modal-body").html(data);

                // Show the modal
                $('#store-stock-info-modal').modal('show');
            },
            error: function (xhr, status, error) {
                console.log('Error occurred while fetching data');
            }
        });
    });

    $(".which-store-is-there-page-get-store").live("click", function () {
        var _productcode = $('#which-store-is-there-page-productcode').val();
        var _colorcode = $('#which-store-is-there-page-colorcode').val();
        var _sizeCode = $('#which-store-is-there-page-sizeid').val();
        var _cityCode = $('#which-store-is-there-page-cityid').val();

        $.ajax({
            url: '/ProductDetails/GetProductInventoryStoreInfo',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                productCode: _productcode,
                colorCode: _colorcode,
                sizeCode: _sizeCode,
                cityCode: _cityCode
            }),
            beforeSend: function () {
                GenerateLocalLoading($("#store-stock-info-modal .modal-body .which-store-is-there-page-second-part"), "show");
            },
            success: function (data) {
                // Populate the modal content with the returned data
                $("#store-stock-info-modal .modal-body .which-store-is-there-page-second-part").html(data);

                //#region We will set min height values all cart items
                var _maxCardHeight = 0;

                $('.which-store-is-there-page-result-area-card-left-side, .which-store-is-there-page-result-area-card-right-side').each(function () {
                    // Get the current element's height
                    var _currentHeight = $(this).outerHeight();

                    // Update max height if the current element's height is greater
                    if (_currentHeight > _maxCardHeight) {
                        _maxCardHeight = _currentHeight;
                    }
                });

                //var _firstCardHeight = $('.which-store-is-there-page-result-area-card-first').outerHeight();

                // Set the min-height of all elements with the class 'another-element'
                $('.which-store-is-there-page-result-area-card-left-side').css('min-height', _maxCardHeight + 'px');
                $('.which-store-is-there-page-result-area-card-right-side').css('min-height', _maxCardHeight + 'px');
                //#endregion
            },
            error: function (xhr, status, error) {
                console.log('Error occurred while fetching data');
            },
            complete: function () {
                GenerateLocalLoading($("#store-stock-info-modal .modal-body .which-store-is-there-page-second-part"), "hide");
            }
        });
    });
}

// Ürün sayfası için yapışkan buton
var productPage_sticky_html = function () {
    var stickyHtml =
        '<div class="product_page_sticky_button_container">' +
        '  <div class="product_page_sticky_button_content">' +
        '    <div class="product_page_sticky_button_top">' +
        '      <div class="product_page_sticky_button_productName"></div>' +
        '    </div>' +
        '    <div class="product_page_sticky_button_bottom">' +
        '      <div class="product_page_sticky_button_colorOptions">' +
        '        <h4 class="colorOptions-count"></h4>' +
        '      </div>' +
        '      <div class="product_page_sticky_button_addToCard AddToBasket ProductDetails AutoTextRep"></div>' +
        '    </div>' +
        '  </div>' +
        '  <div class="product_page_sticky_button_colorOptions_popUp">' +
        '    <div class="product_page_sticky_button_colorOptions_popUp_title">' +
        '      <button class="colorOptions-close btn">' +
        '        <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
        '      </button>' +
        '      <h4>Mevcut Renkler</h4>' +
        '    </div>' +
        '  </div>' +
        '</div>';


    var body = document.querySelector("body");
    body.insertAdjacentHTML("beforeend", stickyHtml);
};

// JavaScript ile oluşturulan yapışkan buton
var productPage_sticky_script = function () {
    var productPage = {
        productName: document.querySelector(".ProductHeader").innerText,
        //price: document.querySelector(".ProductContent .PriceArea").innerHTML,
        colorOptions: document.querySelector(".ItemColorsContainer.product-colors"),
        addToCard: document.getElementById("Basket"),
    };

    var productName = document.querySelector(".product_page_sticky_button_productName");
    //var price = document.querySelector(".product_page_sticky_button_price");
    var colorOptions = document.querySelector(".product_page_sticky_button_colorOptions");
    var colorSection = document.querySelector(".product-colors-wrapper");
    var addToCard = document.querySelector(".product_page_sticky_button_addToCard");

    if (colorSection) {
        colorSection.remove();
    }
    productName.innerHTML = productPage.productName;
    //price.innerHTML = productPage.price;
    if (colorOptions && productPage.colorOptions) {
        colorOptions.insertAdjacentElement("afterbegin", productPage.colorOptions);
    }
    addToCard.insertAdjacentElement("beforeend", productPage.addToCard);

    var checkColorOptions = function () {
        var colorOptions = document.querySelectorAll(".product_page_sticky_button_colorOptions .ColorOption.color-option-wrapper");

        if (colorOptions.length > 2) {
            var colorOptionsCount = document.querySelector(".colorOptions-count");
            colorOptionsCount.classList.add("colorsOptions-count-active");
            colorOptionsCount.innerHTML = "+ " + (colorOptions.length - 2);

            for (var i = 2; i < colorOptions.length; i++) {
                colorOptions[i].style.display = "none";
            }
        }
    };

    var colorOptionsPopUp = function () {
        var colorOptions = document.querySelector(".product_page_sticky_button_colorOptions");
        var colorOptionsPopUp = document.querySelector(".product_page_sticky_button_colorOptions_popUp");
        var colorOptionsClose = document.querySelector('.colorOptions-close');

        colorOptions.addEventListener("click", function () {
            colorOptionsPopUp.classList.add("colorOptions_popUp_active");
        });

        colorOptionsClose.addEventListener("click", function () {
            colorOptionsPopUp.classList.remove("colorOptions_popUp_active");
        });

        var colors = document.querySelector(".ItemColorsContainer.product-colors");
        colorOptionsPopUp.insertAdjacentElement("beforeend", colors.cloneNode(true));

        colors.addEventListener("click", function (e) {
            if (e.target.classList.contains("ColorOption")) {
                colorOptionsPopUp.classList.remove("colorOptions_popUp_active");
            }
        });

        var popUpColors = document.querySelectorAll(".product_page_sticky_button_colorOptions_popUp .ColorOption.color-option-wrapper");
        for (var j = 0; j < popUpColors.length; j++) {
            popUpColors[j].style.display = "flex";
        }
    };

    var imgTitle = function () {
        var imgContainer = document.querySelectorAll(".product_page_sticky_button_colorOptions_popUp .ColorOption .ColorOptionItem");
        var imgContainer_a = document.querySelectorAll(".product_page_sticky_button_colorOptions_popUp .ColorOption .ColorOptionItem a");

        for (var k = 0; k < imgContainer.length; k++) {
            var imgTitles = document.createElement("div");
            imgTitles.classList.add("product_page_sticky_button_colorOptions_popUp_productColorTitle");

            var imgTitleh4 = document.createElement("h4");
            imgTitleh4.innerHTML = imgContainer_a[k].getAttribute("title").toLowerCase();

            imgTitles.appendChild(imgTitleh4);
            imgContainer[k].appendChild(imgTitles);
        }
    };

    //var product_page_sticky_button_price = document.querySelector(".product_page_sticky_button_price");

    //if (product_page_sticky_button_price) {
    //    var textBadge = product_page_sticky_button_price.querySelectorAll(".TextBadge");
    //    for (var l = 0; l < textBadge.length; l++) {
    //        textBadge[l].style.display = "none";
    //    }
    //}

    checkColorOptions();
    colorOptionsPopUp();
    imgTitle();
};

$(document).ready(function () {
    AskQuestions();
    SizeTable();
    Slider();
    StoreStockInfo();

    //window.setTimeout(AddBasketCount, 2000);

    //ImageFix();
    AddToFavoriteNewPd();
    removeFavoriteNewPd();

    var addToBasket = document.querySelector(".AddToBasket");
    var addToBasketFixed = document.querySelector(".AddToBasketFixed");

    if (!isMobileResolution() && addToBasket && addToBasketFixed) {
        function checkVisibility() {
            var rect = addToBasket.getBoundingClientRect();
            if (rect.bottom <= 0) {
                addToBasketFixed.style.display = "block"; // sepete ekle buton görünmüyorsa göster
            } else {
                addToBasketFixed.style.display = "none";
            }
        }

        checkVisibility();
        window.addEventListener("scroll", checkVisibility);
    }

    $(".PrdAddBasketFixed button").on("click", function () {
        $(".AddToBasket #Basket").trigger("click");
    });

    $(".PrdAddFavoriteFixed .passiveFavorite").live("click", function () {
        $("#ProductDetailDivi").find(".passiveFavorite").trigger("click");
    });

    $(".PrdAddFavoriteFixed .activeFavorite").live("click", function () {
        $("#ProductDetailDivi").find(".activeFavorite").trigger("click");
    });

    var stickyBasketButton = document.querySelector(".product_page_sticky_button_container");

    if (!stickyBasketButton) {
        $("#Basket").css("display", "block");
    }

    if ($(".CombineProductsOnPd").length > 0) {
        setTimeout(loadWidgetReports(), 3000);
    }

    $(".CompleteElegance").on("click", function (e) {
        $("#CombineItemsModal").modal("show");
    });

    $(".DetailsRating > span").on("click", function () {
        $('.CommentAccordion #ProductComment').collapse('show');
        $('html,body').animate({
            scrollTop: $(".CommentAccordion #ProductComments").offset().top
        }, 'slow');
    });
    //$('#accordion #collapseComment').on('shown.bs.collapse', function () {
    //    $('html,body').animate({
    //        scrollTop: $(".DetailsAccordion #ProductComments").offset().top
    //    }, 'slow');
    //});

    $(".CombineProductsOnPd .Prd:eq(1)").addClass("col-md-offset-2");

    $miniImage = $('.SmallProductImages ul');
    $detailImage = $('.ProductDetailsMainImage ul');

    $(".SmallProductImages ul li img").removeClass("Selected");
    $(".SmallProductImages ul li:not('.slick-cloned') img").first().addClass("Selected");

    if ($(window).width() < 767) {
        CombinePrdSlider();
    }

    DetailResizing();

    GetSuggestedProducts();
    //GetLastVisitedProducts();
    ReplaceCombineProducts();
    BasketButtonFixed();
    ShowZoomImage();

    var badges = document.querySelectorAll(".ProductDetailsMainImage .badge-left-top-padding");

    if (badges && badges.length > 1) {
        badges.forEach(function (badge, index) {
            if (index > 0) {
                if (window.innerWidth > 992) {
                    badge.style.top = (20 + (index * 30)) + "px";
                }
                else {
                    badge.style.top = (25 + (index * 25)) + "px";
                }
            }
        });
    }

    if (window.innerWidth < 991 && !document.querySelector(".product_page_sticky_button_container") && document.querySelector("body").classList.contains("ProductDetails")) {
        productPage_sticky_html();
        productPage_sticky_script();
    }

    if ($(".CombineProductsOnPd .ProductList .Prd").length > 0) {
        ////$(".CombineProductsOnPd .ProductList .Prd:first").removeClass("col-xs-12").addClass("col-xs-24");
        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 3) {
        //    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-7");
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-6").addClass("col-md-7");
        //}

        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 5) {
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-4").addClass("col-md-5");
        //}

        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 4) {

        //    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-6").addClass("col-md-5");
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-5").addClass("col-md-6");

        //}

        //$(".CombineProductsOnPd .ProductList .Prd:first-child").addClass("PrdFirstPadding");
        ////$(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-6").addClass("col-md-7");
        $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-6");
    }

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {

        $basketButton = $(this);

        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var ProductCode = $basketButton.attr("data-productcode");
        var Productname = $basketButton.attr("data-productname");
        var LangID = $("#LangID").val();
        var CurColor = $("#CurColor").val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        var ColorName = $basketButton.attr("data-color");
        var ProductName = $(".ProductHeader").html();
        var price = $(".PriceItem").html();
        var priceCurrency = $(".PriceCurreny").html();
        var catalogTree = $(".CatalogTree").html();
        var quantity = $(".Quantity").html();
        var ProductAmount = $basketButton.attr('data-amount');
        var ProductOldAmount = parseFloat($basketButton.attr('data-oldAmount'));
        var discount = $basketButton.attr('data-discount');
        var CatID = $basketButton.attr('data-CatID');
        var itemListName = $(this).attr('data-itemListName');


        ProductAmount = parseFloat(ProductAmount);

        if (ProductAmount == ProductOldAmount) {
            ProductAmount = 0;
        }

        if (quantity == undefined) {
            quantity = 1;
        }
        else {
            //quantity değeri ' x' olarak geliyordu
            quantity = quantity.replace("x", "");

            quantity = quantity.replace(" ", "");
        }
        // var value = (ProductAmount * quantity).toFixed(2);

        catalogTree = catalogTree.replace('&gt;', '>');
        catalogTree = catalogTree.replace('&gt;', '>');
        catalogTree = catalogTree.replace('&gt;', '>');
        catalogTree = catalogTree.replace('&amp;', '>');

        var catalogList = catalogTree.split('>');

        var catalogNameList = [];

        for (var i = 0; i < catalogList.length; i++) {

            if (catalogList[i] != null && catalogList[i] != undefined && catalogList[i].length > 0) {

                catalogNameList.push(catalogList[i]);
            }
        }

        var brandName = $basketButton.attr('data-brandname');

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=1" + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {

                    if (catalogNameList != null && catalogNameList != undefined && catalogNameList.length > 0) {
                        //katalog değerlerinin null değil "" gelmesi istendi.
                        var catName1 = null;
                        var catName2 = null;
                        var catName3 = null;


                        for (var i = 0; i < catalogNameList.length; i++) {
                            if (i == 0 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                catName1 = catalogNameList[i];
                            }
                            else if (i == 1 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                catName2 = catalogNameList[i];
                            }
                            else if (i == 2 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                catName3 = catalogNameList[i];
                            }
                            else if (i == 3 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                catName4 = catalogNameList[i];
                            }
                            else if (i == 4 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                catName5 = catalogNameList[i];
                            }

                        }
                        var amount = ProductAmount;

                        if (amount == 0) {
                            amount = ProductOldAmount;
                        }

                        var value = parseFloat(amount);

                        //alert(catName1);
                        //alert(catName2);
                        //alert(catName3);

                        var storedCatalog = localStorage.getItem('selectedCatalog');
                        var storedCatalogID = localStorage.getItem('selectedCatalogID')
                        
                        window.dataLayer = window.dataLayer || [];
                        try {
                            dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                    'currency': 'TRY',
                                    'value': value, // Number olacak. price * quantity olacak. Sadece küsüratta nokta olacak. - toplam
                                    'items': [{
                                        'item_name': Productname,
                                        'item_id': ProductCode,
                                        'affiliation': catName1,
                                        'coupon': '',
                                        'currency': 'TRY',
                                        'discount': parseInt(discount),
                                        'index': 0,
                                        'item_brand': brandName,
                                        'item_category': catName1, // Kaç tane category varsa sırayla eklenecek. Yoksa "" boş gidebilir.
                                        'item_category2': catName2,
                                        'item_category3': catName3,
                                        'item_list_id': parseInt(storedCatalogID),
                                        'item_list_name': storedCatalog,
                                        'item_variant': ColorName.split('-')[0],
                                        'location_id': 'İZ',
                                        'price': ProductOldAmount, // Number olacak.
                                        'quantity': 1, // Number olacak.
                                    }]
                                }
                            });
                        } catch (e) {

                        }
                    }

                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && dt.Deger8 !== '') {

                            var _customModels = dt.Deger8.split("<InsiderObjectBeginning>");

                            if (_customModels !== null) {

                                //#region Related Datalayer Add To Basket Operation
                                if (window.dataLayer !== null && window.dataLayer !== undefined) {
                                    var _dataLayerObject = _customModels[0];

                                    if (_dataLayerObject !== null && _dataLayerObject !== undefined && _dataLayerObject !== '') {
                                        window.dataLayer.push(JSON.parse(_dataLayerObject));
                                    }
                                }
                                //#endregion

                                //#region Insider Object Add To Basket Operation
                                //if (window.insider_object !== null && window.insider_object !== undefined) {
                                //    var _insiderObject = _customModels[1];

                                //    if (_insiderObject !== null && _insiderObject !== undefined && _insiderObject !== '') {
                                //        window.insider_object = JSON.parse(_insiderObject);
                                //    }
                                //}
                                updateInsiderObjectIfChanged(_customModels[1]);
                                //#endregion
                            }
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus > #UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetButton a").trigger("click");

                                setContentHeight();
                            }
                        });

                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {
                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);
                        }

                        if (UseTagManager) {
                            SendCartAddEvent('');
                        }
                    }
                    else {
                        alert(dt.IslemSonucAciklama);
                    }
                }
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {

                if (isMobileResolution()) {
                    $("#PrdBlackBg").show();
                }

                $(".SizeOptions.open").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");

                var sizeText = document.querySelector('.ChooseTitle');
                if (sizeText) {
                    sizeText.classList.add('wiggle-animation');
                }
                setTimeout(function () {
                    sizeText.classList.remove('wiggle-animation');
                }, 3000);

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 200
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {

        $(this).parents(".Sizes").find(".Name").html($(this).attr("data-name"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        //$(this).parent().find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).addClass("active");



        if ($(".NewPD").length > 0) {

            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");

            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");


            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }


            //$(".AmountOptions").addClass("open");

            $(".AddToBasket button").removeClass("NotSelected");


            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {

                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");

            $(".AddToBasket").removeClass("PleaseSelect");

            $("#PrdBlackBg").hide();

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }

        }

        if ($(".LastProducts").length > 0) {

            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
                data: params,
                success: function (data) {

                    if (data != "0" && data != 0) {

                        var prdCls = "";

                        $(".LastProducts").removeClass("One");
                        $(".LastProducts").removeClass("Two");
                        $(".LastProducts").removeClass("More");
                        $(".LastProducts").removeClass("Limited");

                        $(".LastX").html(data);
                        $(".LastPrdHint").html($(".LastPrdHint"));

                        switch (data) {

                            case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                            case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                            case "4": prdCls = "Limited"; break;
                        }

                        $(".LastProducts").addClass(prdCls);
                        $(".LastProducts").show();
                    }
                }
            });
        }
    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {

        $(".SizeOptions .ONE.SIZE").trigger("click");
        //$(".SizeAndAmount").hide();
    }

    $("a.NotifyWhen").live("click", function myfunction() {

        $("#NotifyModal .modal-body").empty();
        $("#NotifyModal").modal("show");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetListForRemind?ProductID=" + $("#ProductID:first").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $(this).parent().parent().parent().find("input[name=SizeIDs]").val(),
            cache: true,
            success: function (data) {
                $("#NotifyModal .modal-body").html(data);
                $(".NotifyColors a:first").trigger("click");
            }
        });
    });

    var lastColorID = 0;

    if ($('.ProductDetail .Colors a.active').length > 0) {
        $(".ProductDetail .Colors .Name").html($('.ProductDetail .Colors a.active').first().attr("data-name"));
    }

    GetHashImage();

    $(window).bind('hashchange', function (e) {
        GetHashImage();
    });

    if ($("div.row.Products").length > 0) {

        var ScrollSize = +70;
        var offsetTop = 0;

        if (isMobile(true)) {
            ScrollSize = 50;
            offsetTop = $(".ToogleFilters:first").offset().top;

        } else if ($("#FilterForm").length > 0) {

            //offsetTop = $("#FilterForm").offset().top
        }

        if (isMobile(true)) {

            $('html, body').animate({
                scrollTop: offsetTop - ScrollSize
            }, 500);
        }
    }

    //if (window.location.hash != undefined && window.location.hash != "") {
    //    GetHashImage();
    //}

    //Amount Option Change
    //$('.AmountOptions .BasketPlus, .AmountOptions .BasketMinus').live("click", function () {

    //    if ($(this).closest(".AmountOptions").hasClass("open") == false) {
    //        return;
    //    }
    //    console.log($(this).attr("class"));

    //    if ($(this).attr("class") == "BasketPlus") {
    //        console.log("123");
    //        if ($(".AmountOptions #Amount").val() >= 9) {
    //            $(".AmountOptions #Amount").val(9)
    //        }
    //        else {

    //            $(".AmountOptions #Amount").val(parseInt($(".AmountOptions #Amount").val()) + 1);
    //        }
    //    }
    //    else {
    //        if ($(".AmountOptions #Amount").val() > 1) {
    //            $(".AmountOptions #Amount").val(parseInt($(".AmountOptions #Amount").val()) - 1);
    //        }
    //        else {
    //            $(".AmountOptions #Amount").val(1)
    //        }
    //    }
    //});

    addQuantity();

    $('.ProductDetail #Amount').live("keyup", function () {

        var yeniAdet = $(this).val();
        $adetKutusu = $(this);

        if (!isNumeric(yeniAdet)) {
            yeniAdet = 1;
        }

        if (yeniAdet <= 1) {

            yeniAdet = 1;
            $adetKutusu.val(1);
        }
        else if (yeniAdet >= 9) {

            yeniAdet = 9;
            $adetKutusu.val(9);
        }
    });

    $(".AmountOptions #Amount").live("change", function () {

        if ($(".AmountOptions #Amount").val() < 1) {

            $(".AmountOptions #Amount").val(1);
        }
        else if ($(".AmountOptions #Amount").val() >= 9) {

            $(".AmountOptions #Amount").val(9);
        }
    });

    $(document).on('click', '.SmallProductImages ul li img', function (event) {
        $(".SmallProductImages ul li img").each(function () {
            $(this).removeClass("Selected");
        });

        $(this).addClass("Selected");

        // Tıklanan resmin indeksini almak için
        var $Index = $(this).closest('li').data('slick-index');

        // Büyük resim güncellemek için
        $detailImage.slick("slickGoTo", $Index);
        //$miniImage.slick("slickGoTo", $Index);

        $(".ProductDetailImages ul li.ImgArea").addClass("gizli");
        $(".ProductDetailImages ul li.ImgArea").each(function () {
            if ($Index === $(this).index()) {
                $(this).removeClass("gizli");
            }
        });
    });

    $('.ProductDetailsMainImage ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $miniImage.slick("slickGoTo", currentSlide);

        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") === currentSlide) {
                $("img", this).addClass("Selected");
            }
            else {
                $("img", this).removeClass("Selected");
            }
        });
    });

    $('.ProductDetailImages .ImgArea a').live("click", function (e) {

        if (isMobile(true) || $(this).closest("#QuickLookModal").length > 0) {

            return false;
            e.preventDefault();
        }
    });

    if ($(window).width() > 1000 && $(".cloudzoomManuel").length > 0 && $("#QuickLookModal").length <= 0) {

        $(".cloudzoomManuel:first").addClass("cloud-zoom").CloudZoom();

    }

    if ($(".Productsuggest").length > 0 && $(".backdrop").length > 0) {

        $(".Productsuggest > .ProductList .Prd").addClass("col-sm-8");
        $(".Productsuggest > .ProductList .Prd").addClass("col-xs-12");
        //$(".Productsuggest > .ProductList .Prd:gt(3)").addClass("hidden-xs");
    }


    if ($(".ProductLastViewedCon").length > 0 && $(".backdrop").length > 0) {

        $(".ProductLastViewedCon .Prd").addClass("col-sm-6");
        $(".ProductLastViewedCon .Prd").addClass("col-xs-12");
        $(".ProductLastViewedCon .Prd:gt(3)").addClass("hidden-xs");
    }

    $("a.SizeTableLink").click(function () {

        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");

        $("#WarningModal").modal("show");

        var ProductID = $(this).closest(".ProductName").next(".CombineColors").find(".ProductID").val();
        var ColorID = $(this).closest(".ProductName").next(".CombineColors").find(".ColorID").val();

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/SizeChart?ProductID=" + ProductID + "&ColorID=" + ColorID,
            success: function (data) {

                $("#WarningModal .modal-body").html(data);

            }
        });

    });

    $(".CloseModal").click(function () {
        $("body").removeClass("BackDropped");
    });

    $(".ProductDetailImages .PrdImgRight").click(function (e) {

        $("#AditionalDescription").remove();

        $currentObject = $(".ProductDetailImages ul li.ImgArea");
        if ($currentObject.not(".mobile-hidden").index() == ($currentObject.length - 1)) {

            $currentObject.addClass("mobile-hidden").first(".ImgArea").removeClass("mobile-hidden");

        } else {

            $currentObject.not(".mobile-hidden").addClass("mobile-hidden").next(".ImgArea").removeClass("mobile-hidden");

        }

        $(".SmallProductImages ul li img").each(function () {
            $ItemIndex = $currentObject.not(".mobile-hidden").index();
            if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                $(this).addClass("Selected");
            }

            $(".SmallProductImages ul li img").each(function () {
                if ($(this).parent().index() != $ItemIndex) {
                    $(this).removeClass("Selected");
                }

            });
        });


    });

    $(".ProductDetailImages .PrdImgLeft").click(function (e) {

        $("#AditionalDescription").remove();

        $currentObject = $(".ProductDetailImages ul li.ImgArea");

        if ($currentObject.not(".mobile-hidden").index() == 0) {

            $currentObject.addClass("mobile-hidden");
            $currentObject.last().removeClass("mobile-hidden");

        } else {

            $currentObject.not(".mobile-hidden").addClass("mobile-hidden").prev(".ImgArea").removeClass("mobile-hidden");

        }

        $(".SmallProductImages ul li img").each(function () {


            $ItemIndex = $currentObject.not(".mobile-hidden").index();
            if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                $(this).addClass("Selected");
            }

            $(".SmallProductImages ul li img").each(function () {
                if ($(this).parent().index() != $ItemIndex) {
                    $(this).removeClass("Selected");
                }

            });
        });

    });

    //$(".ShareText").click(function (e) {
    //    $(".ShareBlocks").toggleClass("active");
    //    $(".ShareText").css("display", "none");
    //});

    //if ($(window).width() < 993) {


    //    $(".ProductDetailImages .ImgArea  img").hammer().on("swipeleft", function (e) {

    //        $(".PrdImgLeft").trigger("click");
    //        e.stopPropagation();
    //        e.preventDefault();
    //    });


    //    $(".ProductDetailImages .ImgArea  img").hammer().on("swiperight", function (e) {

    //        $(".PrdImgRight").trigger("click");
    //        e.stopPropagation();
    //        e.preventDefault();
    //    });

    //}


    var isOpen = false;
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {

        var Amount = $(".PriceItem:first").html();
        var isPr = $(this).hasClass("PrInstallmentOptions");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(",", ""),
            success: function (data) {

                isOpen = !isOpen;
                $(".InstallmentBody").html(data);
                if (isPr) {
                    $("#PdInstallmentOptionsDetail").addClass("collapse in");
                }

                if (isOpen) {

                    $('html, body').animate({
                        scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
                    }, 500);
                }

            }
        });

    });

    function ShowZoomImage() {
        $(".ProductDetailImages .ProductDetailsMainImage ul li img").die("click");
        $('.ProductDetailImages .ProductDetailsMainImage ul li').addClass('fancybox');
    }

    $(window).resize(ShowZoomImage).trigger('resize');

    $(".SmallImageList li").live("click", function () {
        var ImageIndex = $(this).index();
        $(".ProductImageList li").removeClass("selectedImage");
        $(".SmallImageList li").removeClass("selectedImage");
        $(this).addClass("selectedImage");
        $(".ProductImageList li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("selectedImage");
            }
        });

    });

    $(".ThumbImageList li img").live("click", function (event) {
        event.stopPropagation();
        $sliderSlick.slick("slickGoTo", $(this).parent().index());

        $(".ThumbImageList li img").each(function () {

            $(this).removeClass("ThumbActive");

        });

        $(this).addClass("ThumbActive");

    });

    $('.ProductBigSeen').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $(".ThumbImageList li img").each(function () {
            if ($(this).parent().index() == currentSlide) {
                $(this).addClass("ThumbActive");
            }
            else {
                $(this).removeClass("ThumbActive");
            }
        });
    });

    //loadl-more-comment//
    $(document).on("click", ".js-load-more-comment", function () {
        var ProductID = $(this).attr("data-productid");
        var LangID = $("#LangID").val();
        var PageNo = $(this).attr("data-pageNo");
        var ColorID = $("#CurrentColorId").val();
        var Filter = "";

        var RequestData = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID + "&PageNo=" + PageNo;

        if ($(".js-filter-item-element.active").length > 0) {
            Filter = $(".js-filter-item-element.active").first().attr("data-rate");

            RequestData += "&filter=" + Filter;
        }

        GetProductComment(RequestData, function (status, data) {
            if (status) {
                $(".js-load-more-comment").parent(".LoadMore").remove();
                $(".CommentArea").append(data);
            }
        });
    });
    //loadl-more-comment//

    //js filter element//
    $(document).on("click", ".js-filter-item-element", function () {
        var hasFilter = $(".js-filter-item-element.active").length > 0 ? true : false;
        var ProductID = $(this).attr("data-productid");
        var ColorID = $("#CurrentColorId").val();
        var LangID = $("#LangID").val();
        var Filter = "";

        if (!hasFilter) {
            $(this).addClass("active");
            Filter = $(this).attr("data-rate");
        }
        else if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            Filter = "1,2,3,4,5";
        }
        else if (hasFilter) {
            $(".js-filter-item-element.active").removeClass("active");
            $(this).addClass("active");
            Filter = $(this).attr("data-rate");
        }

        var RequestData = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID + "&PageNo=1&filter=" + Filter;

        GetProductComment(RequestData, function (status, data) {
            if (status) {
                $(".CommentArea").html(data);
            }
        });
    });
    //js filter element end//



    //collapse();

    // RatingStarts();

    ProductComment();
});

function GetProductComment(RequestData, callback) {
    $.ajax({
        type: "GET",
        url: "/tr/p/ProductDetails/GetProductComment",
        data: RequestData,
        cache: false,
        beforeSend: function () {
            //GenerateLocalLoading($(".js-load-more-comment"), "show");
            GenerateLocalLoading($(".ProductComments .AppArea"), "show");
        },
        complete: function () {
            //GenerateLocalLoading($(".js-load-more-comment"), "hide");
            GenerateLocalLoading($(".ProductComments .AppArea"), "hide");
        },
        success: function (data) {
            callback(true, data);
        },
        error: function (dt) {
            callback(false, "");
            alert("Yorumlar yüklenirken bir hata oluştu.");
        }
    });
}

function OpenToast(msg) {
    $ToastModal = $(".CommentToastArea");

    $ToastModal.find(".CommentToastLabel").addClass("err");
    $ToastModal.find(".CommentToastLabel").text(msg);

    $ToastModal.find(".CommentToast").fadeIn("normal");
    setTimeout(function () {
        $ToastModal.find(".CommentToast").fadeOut("normal");
    }, 3000);
}

function LoginModalOperation(operation) {
    if (operation == "show") {
        $("body").css("overflow", "hidden");
        $("#LoginModal").show();
    }
    else if (operation == "hide") {
        $("body").css("overflow", "unset");
        $("#LoginModal").hide();
    }
}

function ProductComment() {

    RatingStarts();

    $(document).on("click", ".ProductComments #AddComment, .ProductComments .FirstComment", function () {
        var ProductID = $("#PID").val();
        var ColorID = $("#CurrentColorId").val();

        $.ajax({
            type: "GET",
            url: "/tr/p/ProductDetails/CommentLoginControl",
            data: "ProductID=" + ProductID + "&ColorID=" + ColorID,
            cache: false,
            success: function (data) {

                RatingStarts();

                data = JSON.parse(data);

                if (data.IsLogin == false) {
                    // Giriş yapılmamışsa pop-up penceresini aç
                    $("#LoginRegisterModal2").modal("show");
                }

                else if (data.CanComment == false) {
                    $("#LoginRegisterModal3").modal("show");
                    // Ürünü satın almadıysa uyarı mesajı göster
                    OpenToast("Resmi gazetede çıkan yeni yönetmeliğe göre ürün yorumlarını sadece ürünü satın alan müşteriler yapabilir. Anlayışınız için teşekkür ederiz.");
                }
                else {
                    if (data.HasComment == false) {
                        RateStarsOperation("destroy");
                        RateStarsOperation("init");

                        $("#CommentModal .modal-body .CommentInputArea textarea").val("");

                        if (!$("#CommentModal .modal-footer a").hasClass("disabled")) {
                            $("#CommentModal .modal-footer a").addClass("disabled");
                        }
                        $("#CommentModal").modal("show");
                    }
                    else {

                        $Stars = $("#CommentModal .RateStars");
                        $Stars.rateYo("rating", data.Rating);
                        $("#CommentModal .modal-body .CommentInputArea textarea").val(data.Comment);

                        if (!data.ShowName) {
                            $("#CommentModal .modal-body .CheckItem.ShowName .AllowCheck").removeClass("checked");
                        }

                        if ($("#CommentModal .modal-footer a").hasClass("disabled")) {
                            $("#CommentModal .modal-footer a").removeClass("disabled");
                        }
                    }

                    $("#CommentModal").modal("show");
                }
            },
            error: function (data) {
                window.location.href = "/tr/p/User/Login";
            }
        });
    });

    $(document).on("click", "#CommentModal .modal-footer a", function () {
        $button = $(this);

        if (!$(this).hasClass("disabled")) {

            var getRating = RateStarsOperation("get");
            var errMsg = "";

            if (getRating < 1 || getRating > 5) {
                errMsg = $("#CommentModal .RateWarning").text();
            }

            if (errMsg != "") {
                OpenToast(errMsg);
            }
            else {
                var ProductCode = "";
                var LangID = $("#LangID").val();
                var ProductID = $("#PID").val();
                var ColorID = $(".comment-modal-color-id").val();
                var Comment = $("#CommentModal .modal-body .CommentInputArea textarea").val();
                var AllowShowName = false;

                if ($("#CommentModal .modal-body .CommentModalCheckList .ShowName .AllowCheck").hasClass("checked")) {
                    AllowShowName = true;
                }

                var param = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&ProductCode=" + ProductCode + "&Rate=" + getRating + "&Comment=" + Comment + "&ShowName=" + AllowShowName + "&LangID=" + LangID;

                var CurrentText = $button.text();
                $button.text($button.attr("data-adding") + "...");

                $.ajax({
                    type: "GET",
                    url: "/tr/p/ProductDetails/AddComment",
                    data: param,
                    cache: false,
                    success: function (data) {

                        data = JSON.parse(data);

                        if (data.Sonuc == false) {
                            OpenToast(data.IslemSonucAciklama);
                        }
                        else {
                            $("#CommentModal").modal("hide");

                            $ConfirmModal = $("#ConfirmCommentModal");
                            $ConfirmModal.modal("show");
                            $ConfirmModal.find(".ResultText").text(data.IslemSonucAciklama);
                        }


                        $button.text(CurrentText);

                        $Commentbutton = $(".ProductComments #AddComment");
                        $Commentbutton.text($Commentbutton.attr("data-UpdateCommentText"));

                    },
                    error: function (data) {
                        OpenToast("Sistemde bir hata oluştu. Lütfen bizimle iletişime geçiniz.");
                        $button.text(CurrentText);
                    }
                });
            }
        }
    });

    $(document).on("click", "#CommentModal .modal-body .CommentLabel  .CommentCriterias", function () {
        $("#CommentCriteriasModal").modal("show");
    });

    $(document).on("click", "#ConfirmCommentModal .modal-footer a", function () {
        $("#ConfirmCommentModal").modal("hide");
    });

    $("#ConfirmCommentModal").on('hide.bs.modal', function () {
        location.reload();
    });

    /////////////////////////////////////////////////////////////////

    $(document).on("click", ".btn-comment", function () {

        UserCommentRatingStarts();

        $("#CommentModal .modal-body .CommentInputArea textarea").val("");

        var ProductID = $(this).attr("data-id");
        var ColorID = $(this).attr("data-color-id");
        var UserRate = $(this).attr("data-user-rating");

        $.ajax({
            type: "GET",
            url: "/tr/p/User/CommentModal",
            data: "ProductID=" + ProductID + "&ColorID=" + ColorID + "&UserRate=" + UserRate,
            cache: false,
            success: function (data) {
                data = JSON.parse(data);

                var link = data.URL;
                $(".CmpContent a").attr("href", link);

                RateStarsOperation("destroy");
                RateStarsOperation("init");

                if (data.UserRate !== null) {
                    $Stars = $("#CommentModal .RateStars");
                    $Stars.rateYo("rating", data.UserRate);
                    //console.log(data.UserRate)
                }

                $("#comment-image").attr('src', data.ImagePath);
                $(".CommentModalProductContent .CmpContent .PdName").html(data.ProductName);
                $("#PID").val(data.ProductID);
                $(".comment-modal-color-id").val(data.ColorID);
                $(".CommentInputArea textarea").val(data.Comment);

                $("#CommentModal").modal();

                $('#Private-Close-Modal').click(function () {
                    $('#CommentModal').modal('hide');
                });

            },
            error: function (dt) {
                //window.location.href = "/tr/p/User/Login";
            }
        });

    });
}

function RatingStarts() {
    $Stars = $("#CommentModal .RateStars");

    RateStarsOperation("init");

    //// Rate Stars Change Method
    $Stars.rateYo().on("rateyo.set", function (e, data) {
        $("#CommentModal .RateWarning").hide();
        $("#CommentModal .modal-footer a").removeClass("disabled");
    });

    $("#CommentModal .CommentModalCheckList .CheckItem").on("click", function () {
        $(this).children(".AllowCheck").toggleClass("checked");
    });
}

function RateStarsOperation(operation) {
    $Stars = $("#CommentModal .RateStars");

    if (operation == "init") {
        $Stars.rateYo({
            rating: 0,
            fullStar: true
        });
    }
    else if (operation == "destroy") {
        $Stars.rateYo("destroy");
    }
    else if (operation == "get") {
        return $Stars.rateYo("rating");
    }
}

// Sizin için seçtiklerimiz xtıklama evet'inin datalayer'a gönderilmesi
$(".CombineProductsOnPd .Productsuggest .ProductList .Prd").live("click", function () {
    var itemUrl = $(this).find(".item a")[0].href;
    var amount = $(this).find(".PrdItemBox .PriceArea .PPrice").html();
    amount = amount.substring(2);
    amount = amount.replace(",", ".");

    var json = '{"event":"eecEvent","eventCategory":"Enhanced Ecommerce","eventAction":"Şıklığınızı Tamamlayın Clicks","eventLabel":"' + itemUrl + '","eventValue":"' + amount + '"}';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(JSON.parse(json));
});

function loadWidgetReports() {
    window.dataLayer = window.dataLayer || [];

    for (var i = 1; i < 5; i++) {
        var item = $("#completeYourStyleProductsDataLayer" + i).val();
        if (item != null && item != undefined) {
            var json = JSON.parse(item);
            window.dataLayer.push(json);
        }
    }
}

//function GetSuggestedProducts() {
//    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

//        $.ajax({
//            type: "GET",
//            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
//            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
//            cache: false,
//            success: function (dt) {

//                $(".Suggesteds").remove();

//                if (dt != "") {
//                    $(dt).insertBefore($(".SuggestAndLast"));
//                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-sm-6");
//                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-xs-12");
//                    $(".Suggesteds .Productsuggest .ProductList .Prd:gt(3)").addClass("hidden-xs");
//                }
//            }
//        });
//    }
//}

//function GetLastVisitedProducts() {

//    var colorHash = window.location.hash.split("=");
//    var ColorID = colorHash[1];

//    if (ColorID == undefined || colorHash == undefined || colorHash.length <= 0) {
//        ColorID = $(".Colors a.active:first").attr("data-id");
//    }

//    if ($(".AutoGetLastVisited").length > 0) {
//        $.ajax({
//            type: "GET",
//            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProducts",
//            data: "VisitedPrdID=" + $("#ProductID").val() + "&ColorID=" + ColorID,
//            cache: false,
//            success: function (dt) {
//                $(".LastViewedProducts.AutoSetted").remove();

//                if (dt != "") {
//                    $(".AutoGetLastVisited").append(dt);
//                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
//                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
//                    $(".LastViewedProducts .ProductList .Prd:gt(3)").addClass("hidden-xs");
//                }
//            }
//        });
//    }
//}

//function ImageFix() {
//    var imageMoved = false;
//    $('.ImgArea img').on('ready', function () {
//        var isHorizontal = $(this).width() > $(this).height();
//        if (isHorizontal && !imageMoved) {
//            imageMoved = true;
//            $li = $(this).closest("li");
//            $li.insertBefore($(".ProductDetailsMainImage ul li:eq(2)"));
//            $img = $li.find("img");

//            $img.attr("src", $img.attr("src").split('?')[0]);
//            $li.css("width", "100%");
//        }
//    });
//}


//$(".ProductDetail .DetailsRating > span").on("click", function () {
//    $('html,body').animate({
//        scrollTop: $("#ProductComments").offset().top
//    }, 'slow');
//});

document.addEventListener("DOMContentLoaded", function () {
    function updateLineBreaks() {
        var elements = document.querySelectorAll('.nav-tabs .head a');
        elements.forEach(function (el) {
            if (window.innerWidth <= 768) {
                if (!el.innerHTML.includes('<br>')) {
                    el.innerHTML = el.innerHTML.replace(/ /g, '<br />');
                }
            } else {
                el.innerHTML = el.innerHTML.replace(/<br\s*\/?>/g, ' ');
            }
        });
    }

    // Sayfa yüklendiğinde bir kez çalıştır
    updateLineBreaks();

    // Ekran boyutu değiştiğinde yeniden çalıştır
    window.addEventListener('resize', updateLineBreaks);
});

document.addEventListener("DOMContentLoaded", function () {
    var measurements = document.querySelectorAll('.measurements');
    var rows = document.querySelectorAll('#bedenTable .row');

    // Orijinal konumları sakla
    var originalParentNodes = [];
    measurements.forEach(function (measurement) {
        originalParentNodes.push(measurement.parentNode);
    });

    function updateLayout() {
        if (window.innerWidth <= 768) {
            measurements.forEach(function (measurement, index) {
                if (rows[index]) {
                    rows[index].appendChild(measurement);
                }
            });
        } else {
            measurements.forEach(function (measurement, index) {
                originalParentNodes[index].appendChild(measurement);
            });
        }
    }

    updateLayout();
    window.addEventListener('resize', updateLayout);
});